import React, { useState } from "react";
import { Button, Card, CardHeader, CardBody, Form, FormGroup, InputGroup, InputGroupAddon, InputGroupText, Input } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faUser, faComment, faMap } from "@fortawesome/free-solid-svg-icons";
import { MessageRequest } from "../../../store/messages/types";
import { useForm } from "react-hook-form";
import { FlashMessageNotifier } from "../../../utils/FlashMessageNotifier";
import { apiClient } from "../../../constants";
import { Logger } from "../../../utils/Logger";

export interface ContactUsFormProps {
    onSubmit(messageRequest: MessageRequest): void
}

export const ContactUsForm: React.FC<any> = (props: ContactUsFormProps) => {
    const [formSubmitted, setFormSubmitted] = useState(false);
    const { register, handleSubmit, errors } = useForm<any>();

    interface FormInputs {
        name: string;
        email: string;
        message: string;
        route: string;
    }

    const onSubmit = (data: FormInputs) => {
        const request: MessageRequest = {
            title: `Message from ${data.name} / ${data.email}`,
            message: `${data.message} \n${data.email}\n${data.name}`
        }

        props.onSubmit(request);

        setFormSubmitted(true);
    }

    const transportRoutes: Map<string, string> = new Map([
        ["sydToPer", "Transport from Sydney to Perth"],
        ["perToSyd", "Transport from Perth to Sydney"],
        ["sydInterCity", "Transport within Sydney region"],
        ["perInterCity", "Transport within Perth region"],
        ["other", "Other"]
    ]);

    return (
        <React.Fragment>
            <Card className="bg-secondary shadow border-0">
                <CardHeader className="bg-white pb-5">
                    <div className="text-muted text-center mb-3">
                        <h3 className="mb-1 pt-5">Get a quote</h3>
                        <small>No consignment is too big or small</small>
                    </div>
                </CardHeader>
                <CardBody className="px-lg-5 py-lg-5">
                    <Form role="form" action="https://formsubmit.co/imanlogistics5@gmail.com" method="post">
                        <FormGroup>
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <FontAwesomeIcon icon={faUser} className="mx-2" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input type="text" name="name" placeholder="Name" innerRef={register({ required: true })} invalid={errors.name !== undefined} />
                            </InputGroup>
                        </FormGroup>
                        <FormGroup>
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <FontAwesomeIcon icon={faEnvelope} className="mx-2" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input type="text" name="email" placeholder="Phone / Email" innerRef={register({ required: true })} invalid={errors.email !== undefined} />
                            </InputGroup>
                        </FormGroup>
                        <FormGroup>
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <FontAwesomeIcon icon={faMap} className="mx-2" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input type="select" name="route" innerRef={register({ required: false })} invalid={errors.route !== undefined}>
                                    {
                                        Array.from(transportRoutes.keys()).map(x => {
                                            return <option value={x}>{transportRoutes.get(x)}</option>
                                        })
                                    }
                                </Input>
                            </InputGroup>
                        </FormGroup>
                        <FormGroup>
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <FontAwesomeIcon icon={faComment} className="mx-2" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input type="textarea" name="message" placeholder="Message" innerRef={register({ required: true })} invalid={errors.message !== undefined} />
                            </InputGroup>
                        </FormGroup>
                        <div className="text-center">
                            <Button className="my-4 rounded-pill px-4 py-2 lift lift-sm" color="primary" type="submit" disabled={formSubmitted}>{!formSubmitted ? "Send Request" : "Request sent"}</Button>
                            {formSubmitted && <h5 className="text-white">Thanks for contacting us. We'll be in touch soon.</h5>}
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </React.Fragment>
    );
}

export default ContactUsForm;
